import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "react-image-lightbox/style.css"; // This only needs to be imported once in your app
import App from "./App";
import ReactGA from "react-ga4";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";

const MEASUREMENT_ID = "G-1KSJLZ7Q9S";

ReactGA.initialize(MEASUREMENT_ID, { nonce: "barobprod" });

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="831469226808-tl5c5222q9p200v9intrvq3fjtke2dt9.apps.googleusercontent.com">
    <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
